// RealtimeProvider.tsx — kytkee Socket.IO-yhteyden auth-tilaan.
//
// Kun käyttäjä kirjautuu sisään (= access-token saadaan), socket avataan.
// Kun token muuttuu (refresh), token päivitetään socketille.
// Kun käyttäjä kirjautuu ulos, socket disconnectoidaan.
//
// Liitetään App.tsx:ään RequireAuth:n sisään (vain kirjautuneille).

import { type ReactNode, useEffect } from 'react';
import { useAuth } from '../api/auth';
import { connectSocket, disconnectSocket, setSocketToken } from './socket';
import { getAccessToken } from '../api/client';

export default function RealtimeProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      disconnectSocket();
      return;
    }

    const token = getAccessToken();
    if (token) {
      connectSocket(token);
    }

    // Kuuntele auth:logout-eventtiä (ks. api/client.ts) jotta socket suljetaan
    const onLogout = () => disconnectSocket();
    window.addEventListener('auth:logout', onLogout);

    // Token-päivitysten kuuntelu — apiFetch päivittää _accessToken:n hiljaa,
    // mutta meillä ei ole eventiä siitä. Kierretään: poll-tyylillä joka 30 sek
    // tarkistetaan onko token muuttunut. Halpaa, ei verkkokutsuja.
    const interval = setInterval(() => {
      const t = getAccessToken();
      if (t) setSocketToken(t);
    }, 30_000);

    return () => {
      window.removeEventListener('auth:logout', onLogout);
      clearInterval(interval);
    };
  }, [user]);

  return <>{children}</>;
}
